(ns frontend.ui.component.nested-dropdown.view
  (:require
   [cljs-uuid-utils.core :as uuid]
   [re-frame.core :as rf]
   [react-dom :as react-dom]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.utils :as fu]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.ui.component.nested-dropdown.style :as style]
   [potpuri.core :as potpuri]
   [reagent.core :as r]
   [herb.core :refer [<class]]))


; if the button is closer than 200 px from the bottom of screen, open menu on top

(defn create-uuid
  []
  (->> (uuid/make-random-uuid)
       (uuid/uuid-string)))


(defn get-element-coordinates
  [element-id]
  (if-let [element (.getElementById js/document element-id)]
    (let [rect (.getBoundingClientRect element)
          top (aget rect "top")
          bottom (aget rect "bottom")
          left (aget rect "left")
          right (aget rect "right")
          height (aget rect "height")
          width (aget rect "width")]
      {:top    top
       :right  right
       :left   left
       :bottom bottom
       :width  width
       :height height})
    {:top        0
     :right      0
     :left       0
     :bottom     0
     :width      0
     :height     0
     :not-found? true}))


(defn view
  [{:keys [on-select align-menu]}]
  (let [component-id (create-uuid)
        button-id (str "dropdown-button-" component-id)
        menu-id (str "dropdown-menu-" component-id)

        align-menu (or align-menu :bottom)

        users (->> (session/tenant-users)
                   (mapv (fn [account]
                           (let [{:keys [account/first-name
                                         account/last-name]}
                                 account]
                             {:label (str first-name " " last-name)
                              :key   (:db/id account)}))))

        menu-items [{:label      "Users"
                     :icon       [:i.fal.fa-user.mr-2]
                     :key        :users
                     :menu-items (concat users users)}
                    {:label      "Teams"
                     :icon       [:i.fal.fa-users.mr-2]
                     :key        :teams
                     :menu-items (->> @session/teams
                                      (mapv (fn [team]
                                              {:label (:team/name team)
                                               :key   (:db/id team)})))}]

        top-menu-height (* (count menu-items) 50)

        initial-state {:open?       false
                       :sub-menu    nil
                       :menu-height top-menu-height
                       :align-menu  (or align-menu :bottom)}

        state-atom (r/atom initial-state)

        sub-menu-heights (->> menu-items
                              (map (fn [{:keys [label key menu-items]}]
                                     (let [height (* (+ (count menu-items) 1) 50)]
                                       [key height])))
                              (into {}))

        click-away-listener (fn [e]
                              (let [{:keys [top left right bottom]} (get-element-coordinates menu-id)
                                    click-x (aget e "x")
                                    click-y (aget e "y")
                                    clicked-menu? (and (<= left click-x)
                                                       (<= click-x right)
                                                       (<= top click-y)
                                                       (<= click-y bottom))]
                                (when-not clicked-menu?
                                  (reset! state-atom initial-state))))

        open-menu (fn [e]
                    (if (:open? @state-atom)
                      (swap! state-atom dissoc :open?)
                      (let [{:keys [top right left bottom]} (get-element-coordinates button-id)
                            window-height (.-innerHeight js/window)

                            btn-distance-from-bottom (- window-height bottom)

                            align-menu (if (< btn-distance-from-bottom 250)
                                         :top
                                         align-menu)

                            menu-position {:top  bottom
                                           :left left}]

                        (.addEventListener js/document "click" click-away-listener)

                        (swap! state-atom assoc
                          :button-coords (get-element-coordinates button-id)
                          :menu-position menu-position
                          :align-menu align-menu
                          :open? true))))]
    (fn [{:keys [on-select menu-position]}]
      (let [width 200
            {:keys [open? sub-menu menu-height menu-position button-coords align-menu]} @state-atom
            el (.. js/document (getElementById "react-select-menu-container"))
            window-height (.-innerHeight js/window)

            menu-max-height (if (= align-menu :top)
                              350
                              (- window-height (:bottom button-coords) 20))

            menu-height (min menu-height menu-max-height 350)

            menu-top (if (= align-menu :top)
                       (- (:top button-coords) menu-height)
                       (:bottom button-coords))


            menu-left (:left menu-position)



            button-coordinates (get-element-coordinates button-id)

           ]

        (when-not open?
          (.removeEventListener js/document "click" click-away-listener))

        [:div
         [:button.btn.zap-btn__solid__green.btn-md
          {:id       button-id
           :on-click open-menu}
          [:span "Add"]
          [:i.fas.fa-angle-down.ml-2]]

         (when open?
           (react-dom/createPortal
            (r/as-element
             [:div
              {:style {:position   "absolute"
                       :width      "200px"
                       :top        (str menu-top "px")
                       :left       (str menu-left "px")
                       :background "red"
                       :z-index    "9999"
                       :transition-duration "200ms"}}
              [:div
               {:style {:position "relative"}}
               [:div
                {:id    menu-id
                 :style {:position   "absolute"
                         :width      width
                         ;:height     menu-height
                         :background "white"
                         :box-shadow "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
                         :z-index    "90000"}}

                [:div
                 {:style {:height     menu-height
                          :width      width
                          :position   "relative"
                          :transition-duration "200ms"
                          :overflow-x "hidden"}}
                 [:div
                  {:style {:position "absolute"
                           :transition-duration "200ms"
                           :left     (if sub-menu
                                       "-100%"
                                       "0")
                           :top      "0"
                           :height   menu-height
                           :width    width}}
                  (->> menu-items
                       (map-indexed
                        (fn [idx {:keys [label key icon]}]
                          (let []
                            ^{:key (str key)}
                            [:div
                             {:on-click (fn []
                                          (swap! state-atom assoc
                                            :sub-menu key
                                            :menu-height (get sub-menu-heights key)))
                              :class    (<class style/menu-item)}

                             [:div
                              {:style {:display     "flex"
                                       :align-items "center"}}
                              (when icon
                                [:div
                                 {:style {:width "30px"}}
                                 icon])
                              [:p label]]
                             [:i.fal.fa-angle-right]]))))]

                 (->> menu-items
                      (map-indexed
                       (fn [sub-menu-idx {:keys [label key menu-items]}]
                         (let []
                           ^{:key (str "sub-menu-" sub-menu-idx)}
                           [:div
                            {:style {:position   "absolute"
                                     :transition-duration "200ms"
                                     :left       (if (= sub-menu key)
                                                   "0"
                                                   "100%")
                                     :top        "0"
                                     :height     menu-height
                                     :overflow-y "scroll"
                                     :width      width}}

                            [:div
                             {:on-click (fn []
                                          (swap! state-atom assoc
                                            :sub-menu nil
                                            :menu-height top-menu-height))
                              :style    {:padding     "10px"
                                         :height      "50px"
                                         :display     "flex"
                                         :align-items "center"
                                         :cursor      "pointer"}}
                             [:i.fas.fa-arrow-left.mr-2]
                             [:p label]
                            ]
                            (->> menu-items
                                 (map-indexed (fn [idx {:keys [label key]}]
                                                (let []
                                                  ^{:key (str idx "-" key)}
                                                  [:div
                                                   {:on-click (fn []
                                                                (reset! state-atom initial-state)
                                                                (on-select key))
                                                    :class    (<class style/menu-item)}
                                                   [:p label]]))))]))))
                ]]]])





            el))]))))
